<template>
  <div
    class="item-block"
    @mouseleave.self="handleMouseout"
  >
    <div class="row">
      <div class="col-5">
        <figure
          class="item-block__img"
          v-if="windowTypeImage"
        >
          <img
            class="img-fluid"
            v-if="windowTypeImage"
            :src="windowTypeImage"
          >
        </figure>
        <div class="item-block__content content-small">
          <span><b>{{ item.profile.name }}</b></span>
          <span>{{ item.material.name }}</span>
          <span>{{ item.style.name }}</span>
        </div>
      </div>
      <div class="col-7">
        <div class="item-block__content">
          <span
            class="title"
            v-if="item.name"
            >
            {{ item.name }}
          </span>
          <span v-if="item.width && item.height">
            <b>{{ item.width }}</b> x
            <b>{{ item.height}}</b> mm
          </span>
          <span>
            {{ $t('quantity') }}:
            <b>{{ item.count }} {{ $t('pieceUnit') }}.</b>
          </span>
          <div
            class="item-block__variants"
            v-if="colorsImages && colorsImages.length > 0"
          >
            <span>{{ $t('color') }}:</span>
            <img
              class="variants-img"
              v-for="(imageUrl, index) in colorsImages"
              :key="`${index}-${imageUrl}`"
              :src="imageUrl"
            >
          </div>
        </div>
      </div>
      <div class="col-12">
        <collapse-transition>
          <div class="item-block__desc" v-show="descriptionVisible">
            <p>{{ description }}</p>
          </div>
        </collapse-transition>
      </div>
      <div class="col-12">
        <div class="item-block__options">
          <button
            type="button"
            class="options-btn info-btn"
            :data-tooltip="$t('tooltipInformation')"
            data-placement="right"
            @click="toggleDescription"
          >
            <span
              class="icon"
              aria-hidden="true"
              :class="{
                'icon-cross-remove-sign': descriptionVisible,
                'icon-round-info-button': !descriptionVisible
              }"
            ></span>
          </button>
          <button
            type="button"
            class="options-btn info-btn"
            v-for="(action, index) in actions"
            :key="`action-${index}`"
            :data-tooltip="action.tooltip"
            :data-placement="action.tooltipPlacement || 'top'"
            @click="handleAction(action)"
          >
             <span
              class="icon"
              aria-hidden="true"
              :class="action.icon"
            ></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CollapseTransition } from 'vue2-transitions';

  export default {
    name: 'SidebarItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
      onEdit: Function,
      onCopy: Function,
      onRemove: Function,
    },
    data() {
      return {
        descriptionVisible: false,
        actions: [
          {
            tooltip: this.$i18n.t('tooltipEdit'),
            tooltipPlacement: 'top',
            icon: 'icon-pencil-1',
            handler: this.onEdit,
          },
          {
            tooltip: this.$i18n.t('tooltipDuplicate'),
            tooltipPlacement: 'top',
            icon: 'icon-copy-content',
            handler: this.onCopy,
          },
          {
            tooltip: this.$i18n.t('tooltipRemove'),
            tooltipPlacement: 'left',
            icon: 'icon-delete',
            handler: this.onRemove,
          },
        ],
      };
    },
    methods: {
      toggleDescription() {
        this.descriptionVisible = !this.descriptionVisible;
      },
      handleMouseout() {
        this.descriptionVisible = false;
      },
      async handleAction(action) {
        if (typeof action.handler === 'function') {
          await action.handler();
        }
      },
    },
    computed: {
      windowTypeImage() {
        const { windowType } = this.item;
        return windowType.photo;
      },
      colorsImages() {
        const { colorInner, colorOuter } = this.item;
        const colors = [];

        if (colorInner.photo) {
          colors.push(colorInner.photo);
        }

        if (colorOuter.photo) {
          colors.push(colorOuter.photo);
        }

        return colors;
      },
      description() {
        const {
          safety = {},
          windowType = {},
          windowOpeningType = {},
          innovations = [],
        } = this.item;
        const items = [];

        if (windowType.name) {
          items.push(windowType.name);
        }

        if (windowOpeningType.name) {
          items.push(windowOpeningType.name);
        }

        if (safety.name) {
          items.push(safety.name);
        }

        if (innovations.length > 0) {
          innovations.forEach(innovation => {
            items.push(innovation.name);
          });
        }

        return items.join(', ');
      },
    },
    components: {
      CollapseTransition,
    },
  };
</script>
